import apiClient from "./apiClient";

const companyBranchesApi = {
  getAll: async () => {
    const response = await apiClient.get("/company-branches");
    return response.data;
  },
  getByCompany: async (companyId) => {
    const response = await apiClient.get("/company-branches", { params: { companyId } });
    return response.data;
  },
  getById: async (branchId) => {
    const response = await apiClient.get(`/company-branches/${branchId}`);
    return response.data;
  },
  getBranchSurveyPdf: async (branchId, surveyName) => {
    const response = await apiClient.get(`/company-branches/${branchId}/${surveyName}`);
    return response.data;
  },
  create: async (data) => {
    const response = await apiClient.post("/company-branches", data);
    return response.data;
  },
  update: async (branchId, data) => {
    const response = await apiClient.put(`/company-branches/${branchId}`, data);
    return response.data;
  },
  delete: async (branchId) => {
    const response = await apiClient.delete(`/company-branches/${branchId}`);
    return response.data;
  },
};

export default companyBranchesApi;
